/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".log-list-item_date{position:absolute;top:5px;right:5px;font-size:12px}.log-list-item{margin-bottom:8px;padding:8px;border-bottom:1px solid #474747;min-height:80px;position:relative;overflow:hidden}.log-list-item.selected{background:#83badf}"];
export { styles as styles };
